import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../primitives/Notice/components/Container.js';
import { ParagraphSmall } from '../../primitives/Typography/index.js';
const NoticeUI = ({
  children,
  variant = 'info',
  ...restProps
}, ref) => _jsx(Container, {
  ref: ref,
  variant: variant,
  ...restProps,
  children: _jsx(ParagraphSmall, {
    children: children
  })
});
export const Notice = /*#__PURE__*/_styled(forwardRef(NoticeUI), {
  label: 'Notice',
  target: "ess3air0"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk5vdGljZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRRyIsImZpbGUiOiJOb3RpY2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvTm90aWNlL2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmltcG9ydCB7IFBhcmFncmFwaFNtYWxsIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9UeXBvZ3JhcGh5L2luZGV4LmpzJztcbmNvbnN0IE5vdGljZVVJID0gKHsgY2hpbGRyZW4sIHZhcmlhbnQgPSAnaW5mbycsIC4uLnJlc3RQcm9wcyB9LCByZWYpID0+IChfanN4KENvbnRhaW5lciwgeyByZWY6IHJlZiwgdmFyaWFudDogdmFyaWFudCwgLi4ucmVzdFByb3BzLCBjaGlsZHJlbjogX2pzeChQYXJhZ3JhcGhTbWFsbCwgeyBjaGlsZHJlbjogY2hpbGRyZW4gfSkgfSkpO1xuZXhwb3J0IGNvbnN0IE5vdGljZSA9IHN0eWxlZChmb3J3YXJkUmVmKE5vdGljZVVJKSwge1xuICAgIGxhYmVsOiAnTm90aWNlJyxcbn0pIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Tm90aWNlLmpzLm1hcCJdfQ== */");